/**
 * Integrations Module Routes
 *
 * Route definitions for the Integrations module.
 * All routes are scoped to admin users.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/integrations',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.integrations',
        },
        children: [
            {
                path: '',
                name: 'integrations-list',
                component: () => import('./views/IntegrationList.vue'),
                meta: {
                    title: 'Integrations',
                },
            },
            {
                path: ':system/setup',
                name: 'integrations-setup',
                component: () => import('./views/IntegrationSetup.vue'),
                meta: {
                    title: 'Connect Integration',
                },
            },
            {
                path: ':system',
                name: 'integrations-detail',
                component: () => import('./views/IntegrationDetail.vue'),
                meta: {
                    title: 'Integration Details',
                },
            },
            {
                path: 'apollo/sync',
                name: 'integrations-bulk-sync',
                component: () => import('./views/BulkSync.vue'),
                meta: {
                    title: 'Bulk Sync',
                },
            },
            {
                path: 'apollo/sync/tenants',
                name: 'integrations-bulk-tenant-sync',
                component: () => import('./views/BulkTenantSync.vue'),
                meta: {
                    title: 'Bulk Tenant Sync',
                },
            },
        ],
    },
]

export default routes
